import { render, staticRenderFns } from "./VerifyOTP.vue?vue&type=template&id=f51e8c18&scoped=true"
import script from "./VerifyOTP.vue?vue&type=script&lang=js"
export * from "./VerifyOTP.vue?vue&type=script&lang=js"
import style0 from "./VerifyOTP.vue?vue&type=style&index=0&id=f51e8c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51e8c18",
  null
  
)

export default component.exports